import { buildTourPath } from "pages/PageConfigs";
import { TourContainer, TourLogoContainer, TourTrigrams } from "./styles";
import { selectTourTrigram } from "selectors/Tour";
import { TourLogo } from "components/Logo/TourLogo";
import { useAppSelector } from "app/hooks";
import { PlainNavLink } from "styles/elements";

interface Props {
  tourId: string;
  hoverColor?: string;
}

export const CompactTourListItem = ({ tourId, hoverColor }: Props) => {
  const tourTrigram = useAppSelector((state) =>
    selectTourTrigram(state, tourId)
  );

  return (
    <PlainNavLink to={buildTourPath(tourId)}>
      <TourContainer>
        <TourTrigrams>
          <span>{tourTrigram}</span>
        </TourTrigrams>
        <TourLogoContainer>
          <TourLogo id={tourId} />
        </TourLogoContainer>
      </TourContainer>
    </PlainNavLink>
  );
};
